import useApiHelpers from '@/composables/api/helpers';
import { useTrackingStore } from '@/stores/tracking/trackingStore';

export default () => {
  const { getRequest } = useApiHelpers();

  /**
   * Checks the url for id param to then call the getOrderInfo api
   * @param {any} callback
   * @returns {Boolean callback| Promise callback}
   * */

  const getApiOrder = () => {
    const params = new URLSearchParams(window.location.search);

    if (!params.has('id')) {
      return false;
    }

    return getRequest(`/getOrderInfo/${params.get('id')}`)
      .then((res) => {
        const { orderId } = res.data;
        const trackingStore = useTrackingStore();
        trackingStore.recordOrderKey(orderId);
        return res;
      });
  };

  const getPAPIOrder = () => {
    const params = new URLSearchParams(window.location.search);

    if (!params.has('initId')) {
      return false;
    }

    return getRequest(`/getPAPIOrderInfo/${params.get('initId')}`)
      .then((res) => {
        const { orderId } = res.data;
        const trackingStore = useTrackingStore();
        trackingStore.recordOrderKey(orderId);
        return res;
      });
  };

  const getMerchSettings = () => new Promise((resolve, reject) => {
    getRequest('/get-base-merchant-settings').then((res) => {
      resolve(res);
    }).catch((error) => {
      reject(error);
    });
  });

  const getNotificationSettings = () => new Promise((resolve, reject) => {
    getRequest('/notifications').then((res) => {
      resolve(res);
    }).catch((error) => {
      reject(error);
    });
  });

  return {
    getApiOrder,
    getMerchSettings,
    getNotificationSettings,
    getPAPIOrder,
  };
};
